import { useTranslate } from '@va/localization';
import { TextFilter } from '@va/shared/feature-filters';
import { buildNestedFiltersPage, FilterOperators } from '@va/types/filters';
import { useMemo } from 'react';

export const useVisitMetadataFilters = () => {
  const translate = useTranslate();

  const metadataTypeFilter = useMemo(
    () =>
      new TextFilter({
        id: 'metadata.type',
        name: 'metadata.type',
        label: translate('filter.metadata.type'),
        operator: FilterOperators.is,
        multiSelectButtonLabel: translate('filters.labels.multiSelect.addValue'),
        operatorOptions: [FilterOperators.is, FilterOperators.contains, FilterOperators.doesNotContain],
        allowMultiSelect: true,
      }),
    [translate],
  );

  const metadataAuthorIdFilter = useMemo(
    () =>
      new TextFilter({
        id: 'metadata.author.id',
        name: 'metadata.author.id',
        label: translate('filter.metadata.authorId'),
        operator: FilterOperators.is,
        multiSelectButtonLabel: translate('filters.labels.multiSelect.addValue'),
        operatorOptions: [FilterOperators.is, FilterOperators.contains, FilterOperators.doesNotContain],
        allowMultiSelect: true,
      }),
    [translate],
  );

  const metadataAuthorNameFilter = useMemo(
    () =>
      new TextFilter({
        id: 'metadata.author.name',
        name: 'metadata.author.name',
        label: translate('filter.metadata.authorName'),
        operator: FilterOperators.is,
        multiSelectButtonLabel: translate('filters.labels.multiSelect.addValue'),
        operatorOptions: [FilterOperators.is, FilterOperators.contains, FilterOperators.doesNotContain],
        allowMultiSelect: true,
      }),
    [translate],
  );

  const metadataBlockNameFilter = useMemo(
    () =>
      new TextFilter({
        id: 'metadata.block.name',
        name: 'metadata.block.name',
        label: translate('filter.metadata.blockName'),
        operator: FilterOperators.is,
        multiSelectButtonLabel: translate('filters.labels.multiSelect.addValue'),
        operatorOptions: [FilterOperators.is, FilterOperators.contains, FilterOperators.doesNotContain],
        allowMultiSelect: true,
      }),
    [translate],
  );

  const metadataCategoryIdFilter = useMemo(
    () =>
      new TextFilter({
        id: 'metadata.category.id',
        name: 'metadata.category.id',
        label: translate('filter.metadata.categoryId'),
        operator: FilterOperators.is,
        multiSelectButtonLabel: translate('filters.labels.multiSelect.addValue'),
        operatorOptions: [FilterOperators.is, FilterOperators.contains, FilterOperators.doesNotContain],
        allowMultiSelect: true,
      }),
    [translate],
  );

  const metadataCategoryNameFilter = useMemo(
    () =>
      new TextFilter({
        id: 'metadata.category.name',
        name: 'metadata.category.name',
        label: translate('filter.metadata.categoryName'),
        operator: FilterOperators.is,
        multiSelectButtonLabel: translate('filters.labels.multiSelect.addValue'),
        operatorOptions: [FilterOperators.is, FilterOperators.contains, FilterOperators.doesNotContain],
        allowMultiSelect: true,
      }),
    [translate],
  );

  const metadataCategorySlugFilter = useMemo(
    () =>
      new TextFilter({
        id: 'metadata.category.slug',
        name: 'metadata.category.slug',
        label: translate('filter.metadata.categorySlug'),
        operator: FilterOperators.is,
        multiSelectButtonLabel: translate('filters.labels.multiSelect.addValue'),
        operatorOptions: [FilterOperators.is, FilterOperators.contains, FilterOperators.doesNotContain],
        allowMultiSelect: true,
      }),
    [translate],
  );

  const metadataTagIdFilter = useMemo(
    () =>
      new TextFilter({
        id: 'metadata.tag.id',
        name: 'metadata.tag.id',
        label: translate('filter.metadata.tagId'),
        operator: FilterOperators.is,
        multiSelectButtonLabel: translate('filters.labels.multiSelect.addValue'),
        operatorOptions: [FilterOperators.is, FilterOperators.contains, FilterOperators.doesNotContain],
        allowMultiSelect: true,
      }),
    [translate],
  );

  const metadataTagNameFilter = useMemo(
    () =>
      new TextFilter({
        id: 'metadata.tag.name',
        name: 'metadata.tag.name',
        label: translate('filter.metadata.tagName'),
        operator: FilterOperators.is,
        multiSelectButtonLabel: translate('filters.labels.multiSelect.addValue'),
        operatorOptions: [FilterOperators.is, FilterOperators.contains, FilterOperators.doesNotContain],
        allowMultiSelect: true,
      }),
    [translate],
  );

  const metadataTagSlugFilter = useMemo(
    () =>
      new TextFilter({
        id: 'metadata.tag.slug',
        name: 'metadata.tag.slug',
        label: translate('filter.metadata.tagSlug'),
        operator: FilterOperators.is,
        multiSelectButtonLabel: translate('filters.labels.multiSelect.addValue'),
        operatorOptions: [FilterOperators.is, FilterOperators.contains, FilterOperators.doesNotContain],
        allowMultiSelect: true,
      }),
    [translate],
  );

  const allFilters = useMemo(
    () => [
      metadataTypeFilter,
      metadataAuthorIdFilter,
      metadataAuthorNameFilter,
      metadataBlockNameFilter,
      metadataCategoryIdFilter,
      metadataCategoryNameFilter,
      metadataCategorySlugFilter,
      metadataTagIdFilter,
      metadataTagNameFilter,
      metadataTagSlugFilter,
    ],
    [
      metadataAuthorIdFilter,
      metadataAuthorNameFilter,
      metadataBlockNameFilter,
      metadataCategoryIdFilter,
      metadataCategoryNameFilter,
      metadataCategorySlugFilter,
      metadataTagIdFilter,
      metadataTagNameFilter,
      metadataTagSlugFilter,
      metadataTypeFilter,
    ],
  );

  const nestedFiltersPage = useMemo(() => {
    return buildNestedFiltersPage({
      label: translate('filters.groups.metadata.label'),
      filters: Object.values(allFilters),
      id: 'metadata-filters',
      name: 'metadata-filters',
    });
  }, [allFilters, translate]);

  return {
    nestedFiltersPage,
    allFilters,
  };
};
